<app-header></app-header>
<div class="spallasx">
	<!-- <nav class="main-menu hidden-xs">
		<ul>
		</ul>
	</nav> -->
	<section class="top-cta"></section>
</div>
<div class="content">
	<div>
		<form
			name="registrationForm"
			[formGroup]="userForm"
		>
			<section class="form">
				<div id="workForm">
					<h2>{{ "user.signup.details" | translate }}</h2>
					<div class="form-registrazione">
						<fieldset class="row">
							<div class="d-sm-table-row">
								<div class="field col-sm-4">
									<label for="surname">{{ "user.signup.surname" | translate }}*</label>
									<input
										[class.error-input]="userForm.controls.surname.touched && userForm.controls.surname.invalid"
										id="surname"
										required
										type="text"
										name="surname"
										formControlName="surname"
										maxlength="80"
										placeholder="{{ 'user.signup.surname' | translate }}"
									/>
								</div>
								<div class="field col-sm-4">
									<label for="name">{{ "user.signup.name" | translate }}*</label>
									<input
										[class.error-input]="userForm.controls.name.touched && userForm.controls.name.invalid"
										id="name"
										type="text"
										required
										name="name"
										formControlName="name"
										class=""
										maxlength="80"
										placeholder="{{ 'user.signup.name' | translate }}"
									/>
								</div>
								@if (country === "IT") {
									<div class="field col-sm-4">
										<label for="fiscalCode">{{ "user.signup.fiscalCode" | translate }}* </label>
										<input
											[class.error-input]="userForm.controls.fiscalCode.touched && userForm.controls.fiscalCode.invalid"
											id="fiscalCode"
											type="text"
											name="fiscalCode"
											formControlName="fiscalCode"
											maxlength="50"
											placeholder="{{ 'user.signup.fiscalCode' | translate }}"
											(change)="showCFError = false"
										/>
										@if (showCFError) {
											<div class="error-info">
												{{ "registrationForm.error.dataErrorFiscalCode" | translate }}
											</div>
										}
									</div>
								}
							</div>

							<div class="d-sm-table-row">
								<div class="field col-sm-4">
									<label>
										{{ "user.signup.birthDate" | translate }}
										@if (country === "IT") {
											*
										}
									</label>
									<input
										style="margin-bottom: 6px"
										type="text"
										[class.error-input]="userForm.controls.birthDate.touched && userForm.controls.birthDate.invalid"
										placeholder="DD/MM/YYYY"
										class="form-control"
										bsDatepicker
										formControlName="birthDate"
										#dpStart="bsDatepicker"
										placement="right"
										[bsConfig]="bsConfig"
									/>
								</div>
								<div class="field col-sm-4">
									<label>{{ "user.signup.email" | translate }}</label>
									<span>{{ userForm?.controls["email"].value }}</span>
								</div>
								<div class="field col-sm-4">
									<label>{{ "user.signup.dealer" | translate }}</label>
									<span>{{ userForm?.controls["idDealer"].value }} - {{ userForm?.controls["dealerName"].value }}</span>
								</div>
							</div>
							<div class="d-sm-table-row">
								<div class="field col-sm-12">
									<h3>{{ "signup.consents" | translate }}</h3>
								</div>
							</div>

							<div class="d-sm-table-row">
								<div class="col-sm-12">{{ "consensi.privacy" | translate }}</div>
							</div>

							<div class="d-sm-table-row">
								<div class="col-sm-12 text-center">
									<input
										type="radio"
										name="consent1"
										[value]="true"
										formControlName="consent1"
										[class.error-input]="userForm.controls.consent1.dirty && userForm.controls.consent1.invalid"
									/>
									{{ "user.agree" | translate }}
									<input
										type="radio"
										name="consent1"
										[value]="false"
										formControlName="consent1"
										[class.error-input]="userForm.controls.consent1.dirty && userForm.controls.consent1.invalid"
									/>
									{{ "user.disagree" | translate }}
								</div>
								<div class="col-sm-12">
									<div>
										<p
											dir="ltr"
											style="text-align: center"
										>
											<strong>
												<span style="font-size: 14px">
													<span style="font-family: arial, helvetica, sans-serif">{{ "consenso-1.p1" | translate }}</span>
												</span>
											</strong>
										</p>
										<p dir="ltr">
											<span style="font-size: 14px">
												<span style="font-family: arial, helvetica, sans-serif">{{ "consenso-1.p2" | translate }}</span>
											</span>
										</p>
									</div>
								</div>
							</div>

							<div class="d-sm-table-row">
								<div class="col-sm-12 text-center">
									<input
										type="radio"
										name="consent2"
										[value]="true"
										formControlName="consent2"
										[class.error-input]="userForm.controls.consent2.dirty && userForm.controls.consent2.invalid"
									/>
									{{ "user.agree" | translate }}
									<input
										type="radio"
										name="consent2"
										[value]="false"
										formControlName="consent2"
										[class.error-input]="userForm.controls.consent2.dirty && userForm.controls.consent2.invalid"
									/>
									{{ "user.disagree" | translate }}
								</div>
								<div class="col-sm-12">
									<div>
										<p
											dir="ltr"
											style="text-align: center"
										>
											<strong>
												<span style="font-size: 14px">
													<span style="font-family: arial, helvetica, sans-serif">{{ "consenso-2.p1" | translate }}</span>
												</span>
											</strong>
										</p>
										<p dir="ltr">
											<span style="font-size: 14px">
												<span style="font-family: arial, helvetica, sans-serif">{{ "consenso-2.p2" | translate }}</span>
											</span>
										</p>
									</div>
								</div>
							</div>

							<div class="d-sm-table-row">
								<div class="col-sm-12 text-center">
									<input
										type="radio"
										name="consent3"
										[value]="true"
										formControlName="consent3"
										[class.error-input]="userForm.controls.consent3.dirty && userForm.controls.consent3.invalid"
									/>
									{{ "user.agree" | translate }}
									<input
										type="radio"
										name="consent3"
										[value]="false"
										formControlName="consent3"
										[class.error-input]="userForm.controls.consent3.dirty && userForm.controls.consent3.invalid"
									/>
									{{ "user.disagree" | translate }}
								</div>
								<div class="col-sm-12">
									<div>
										<p
											dir="ltr"
											style="text-align: center"
										>
											<strong>
												<span style="font-size: 14px">
													<span style="font-family: arial, helvetica, sans-serif">{{ "consenso-3.p1" | translate }}</span>
												</span>
											</strong>
										</p>
										<p dir="ltr">
											<span style="font-size: 14px">
												<span style="font-family: arial, helvetica, sans-serif">{{ "consenso-3.p2" | translate }}</span>
											</span>
										</p>
									</div>
								</div>
							</div>

							<div class="d-sm-table-row">
								<div class="col-sm-12 text-center">
									<span>
										<a
											[class.disabled]="!userForm.valid"
											(click)="onSubmit()"
											class="btn btn-red"
										>
											{{ "user.signup.signup" | translate }}
										</a>
									</span>
								</div>
							</div>
						</fieldset>
					</div>
				</div>
			</section>
		</form>
	</div>
</div>